/**
 * Video Modal
 */

// Vendors
import $ from 'jquery';

// Play button event handler
$('[data-video-modal]').on('click', (event) => {
  if (!event) return;

  event.preventDefault();

  const self = $(event.currentTarget);
  const videoId = self.data('video-id');
  const videoSource = self.data('video-source');
  const videoTitle = self.data('video-title');
  const videoDescription = self.data('video-description');
  const videoIframe = document.createElement('iframe');
  const videoSources = {
    youtube: `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&autoplay=1&rel=0`,
    vimeo: `https://player.vimeo.com/video/${videoId}?badge=0&byline=0&portrait=0&title=0&autoplay=1&autopause=0`
  };

  if (!videoSources[videoSource]) return;

  videoIframe.className = 'video-modal__iframe';
  videoIframe.setAttribute('allowFullScreen', '');
  videoIframe.setAttribute('allow', 'autoplay');

  $('.video-modal__title').text(videoTitle);
  $('.video-modal__description').text(videoDescription);
  $('.video-modal__player').append(videoIframe);

  videoIframe.src = videoSources[videoSource];

  if (videoTitle) $('.video-modal').addClass('video-modal--has-title');
  if (videoDescription)
    $('.video-modal').addClass('video-modal--has-description');

  $('html, body').addClass('modal-is-visible');
  $('.video-modal').addClass('modal--visible');
});

$('[data-modal-close]').on('click', (event) => {
  if (event) event.preventDefault();

  $('html, body').removeClass('modal-is-visible');
  $('.video-modal').removeClass('modal--visible');

  setTimeout(() => {
    $('.video-modal').removeClass('video-modal--has-title');
    $('.video-modal').removeClass('video-modal--has-description');
    $('.video-modal__title').text('');
    $('.video-modal__description').text('');
    $('.video-modal__iframe').remove();
  }, 300);
});
